<template>
  <div @click="openNotif = true">
    <div class="online">
        <div class="ong" v-if="online"></div>
        <div v-else class="loader"></div>
      </div>
    <div class="hed" @click="openNotif = true" :class="{anim:state.length > 0}">
    <svg   v-show="!startActivity" :class="{animcolor:(!startActivity && state.length > 0)}" width="22" height="22" viewBox="0 0 24 24" fill="none"    xmlns="http://www.w3.org/2000/svg">
          <path d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z" stroke="currentColor" stroke-width="1.4"/>
          <path d="M9 17V18C9 18.7956 9.31607 19.5587 9.87868 20.1213C10.4413 20.6839 11.2044 21 12 21C12.7956 21 13.5587 20.6839 14.1213 20.1213C14.6839 19.5587 15 18.7956 15 18V17" stroke="currentColor" stroke-width="1.4"/>
        </svg>
      <p v-show="startActivity && state.length > 0">{{ state.length }}</p>

   </div>
   </div>
  <transition name="slimeright">
      <slotokno :close="() => openNotif = false" :text="'Уведомления'" v-if="openNotif">
        <div class="contentNorif">
          <div class="menuNot">
               <p class="nocopy" v-if="state.length > 0" @click="clearAll()">Удалить все</p>
               <p v-else>Нет уведомлений</p>
         </div>
          <div class="oneNotification" v-for="one of state">
            <p class="close nocopy" @click="closeMessage(one._id)">X</p>
            <p class="title">{{ one.text }}</p>
            <div class="button" v-if="one.url !== null" style="margin-top:10px">Перейти</div>
          </div>

        </div>
      </slotokno>
  </transition>
</template>

<script setup>
import { state, online, closeMessage } from '@/sse'
import { onMounted, ref, watch } from 'vue'

const startActivity = ref(false)
const openNotif = ref(false)
let intervalId = null

const clearAll = async () => {
  for (const one of state.value) {
    await closeMessage(one._id)
  }
}

const toggleInterval = () => {
  if (state.value.length == 0) {
    clearInterval(intervalId)
    startActivity.value = false
  } else {
    intervalId = setInterval(() => {
      startActivity.value = true
      setTimeout(() => startActivity.value = false, 1500)
    }, 3000)
  }
}

watch(() => state.value, (n, o) => {
  console.log('YES')
  toggleInterval()
}, { deep: true })

onMounted(() => {
  //toggleInterval()
})

</script>

<style scoped>
.hed{
  
}

.hed p{
  font-weight: 300;
}

.anim{

}
.animcolor{
  animation: scale-up-center 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) infinite alternate-reverse both;
}
.animcolor path{
  fill:red !important;
  animation: li 500ms;
      stroke: none;
}

.anim p {

  animation: scale-up-center 1s cubic-bezier(0.390, 0.575, 0.565, 1.000) infinite alternate both;
}

.ong{
  width: 9px;
  height: 9px;
  display: block;
  border-radius: 100%;
  background: green;
  margin-right: 10px;
}

.loader {
  width: 9px;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 2px solid;
  border-color: #f12323 #9e9e9e54;
  animation: l1 1s infinite;
  margin-right: 10px;
  animation: l1 1s infinite;
}
@keyframes l1 {to{transform: rotate(.5turn)}}
@keyframes scale-up-center {
0% {
  -webkit-transform: scale(0.5);
          transform: scale(0.5);
          opacity: 0;
}
100% {
  -webkit-transform: scale(1);
          transform: scale(1);
          opacity: 1;
}
}

.oneNotification{
    border-radius: 20px;
    border: 1px solid #e9e9e9;
    box-shadow: 0px 0px 8px 1px #e9e9e9;
    padding:20px;
    margin-top: 20px;
}

.online{
  position: absolute;
}

.contentNorif{
  padding-bottom: 20px;
}
.close{
    position: absolute;
    right: 18px;
    transform: translateY(-22px) translateX(10px);
    font-weight: 300;
    display: grid;
    align-items: center;
    justify-items: center;
    width: 20px;
    height: 20px;
    border-radius: 100%;
    padding: 2px;
    font-size: 13px;
    border: 1px solid #e9e9e9;
    box-shadow: 0px 0px 8px 1px #e9e9e9;
}
.button{
    padding: 0px;
    color: var(--black);
    background: var(--blackgrey);
}
.menuNot{
    display: grid;
    align-items: center;
    justify-items: center;
    margin-top: 20px;
}
</style>
